import styled from "@emotion/styled";

import Card from "@/components/data/Card";
import { Body, Display } from "@/components/Typography";
import Button from "@/components/input/Button";
import { screenLargerThan } from "@/styles";

export const StyledPage = styled.div`
  position: relative;
  background: var(--clr-background-ukwn-1, #fafafa);
`;

export const StyledRightContainer = styled.div`
  ${screenLargerThan.tablet} {
    padding-left: calc(21.5rem + 16.5vw);
    padding-right: 12vw;
  }
`;

export const StyledContainer = styled.div`
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
`;

export const StyledProfileContentContainer = styled.div`
  padding-block: 2.5rem;
`;

export const StyledDetailsCardContainer = styled.div`
  padding: 1rem;

  ${screenLargerThan.tablet} {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 1.5rem;
  }
`;

export const StyledCard = styled(Card)`
  bottom: 0;
  height: fit-content;
  padding: 3.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--clr-primary-100, #5f57ff);
  box-shadow: 0 0.6021873017743928px 0.6021873017743928px -1.25px #0000002e,
    0 2.288533303243457px 2.288533303243457px -2.5px #00000029,
    0 10px 10px -3.75px #00000010;
`;

export const StyledHeading = styled(Display)`
  font-size: 3rem !important;
`;

export const StyledCtaButton = styled(Button)`
  padding: 0.75rem 1rem;

  ${screenLargerThan.tablet} {
    padding: 1rem 2.5rem;
    border-radius: 10rem;
  }
`;

export const StyledUserImage = styled.img`
  height: 14rem;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  object-fit: cover;
  border-radius: 1rem;
`;

export const StyledId = styled.div`
  font-size: 1.75rem;
  font-weight: 300;
  margin-top: 3.5rem;
`;

//-------------- SECTION

export const StyledSection = styled.section<{ $fullHeight?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 2rem 1rem;
  ${({ $fullHeight = true }) =>
    $fullHeight ? "min-height: 100vh;" : "padding-bottom: 8rem;"};

  .section_title + .section__heading {
    border: 1px solid red;
  }
`;

export const StyledFooter = styled.footer`
  background: var(--clr-primary-100, #5f57ff);
  padding: 5.5rem 1rem;
  color: #fff;

  .heading {
    font-size: 4.5rem;
    font-weight: 300;
  }

  .sub-heading {
    font-size: 2rem;
    font-weight: 300;
  }

  .cta-section {
    display: flex;
    gap: 1.5rem;
  }

  .features-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.5rem;
    padding-block: 2rem;

    & > * {
      font-size: 1.25rem;
      font-weight: 400;
    }
  }
`;

export const StyledSectionHeading = styled(StyledHeading)`
  font-weight: 300 !important;

  b {
    font-weight: inherit;
    color: var(--clr-primary-100, #5f57ff);
  }
`;

export const StyledSectionContentContainer = styled.div`
  flex: 1;
  padding-block: 3rem;
  width: 100%;
`;

export const StyledSectionContent = styled(Body)`
  font-size: 2.5rem !important;
  line-height: 1.1em !important;
  font-weight: 300 !important;
`;
